
import Navbar from './components/Navbar';
import HeroBanner from './components/HeroBanner';
import ThreeTierShowcase from './components/ThreeTierShowcase';
import TrustStatistics from './components/TrustStatistics';
import ProductCategories from './components/ProductCategories';
import FeaturedProjects from './components/FeaturedProjects';
import Testimonials from './components/Testimonials';
import LearnTeaser from './components/LearnTeaser';
import StockistCTA from './components/StockistCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="overflow-x-hidden">
      <Navbar />
      <HeroBanner />
      <ThreeTierShowcase />
      <TrustStatistics />
      <ProductCategories />
      <FeaturedProjects />
      <Testimonials />
      <LearnTeaser />
      <StockistCTA />
      <Footer />
    </div>
  );
}
